/**
 * Carga el UMD de toastr como script clásico.
 * Un `import` ESM hace que Vite entre en la rama CommonJS/AMD (`define`/`require`).
 */
import toastrUrl from 'toastr/build/toastr.min.js?url';

export default function cargarToastr() {
  if (window.toastr) {
    return Promise.resolve(window.toastr);
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = toastrUrl;
    script.async = false;
    script.onload = () => {
      if (!window.toastr) {
        reject(new Error('toastr no se registró en window tras cargar el script'));
        return;
      }
      resolve(window.toastr);
    };
    script.onerror = () => reject(new Error(`No se pudo cargar toastr desde ${toastrUrl}`));
    document.head.appendChild(script);
  });
}
